/**
 * URLPoliciesCtrl controller
 *
 */

// controller mixins
URLPoliciesCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * URLPoliciesCtrl controller
 *
 * @class URLPoliciesCtrl
 * @memberof mwApp/streams
 * @see mwApp/streams
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/streams.controller:URLPoliciesCtrl
 */
/* @ngInject */
export default function URLPoliciesCtrl ($scope, UrlPolicy) {
  const vm = this
  // vm.defaultPolicy = defaultPolicy

  vm.getURLPolicies = function (tableState) {
    UrlPolicy.loadSmart(tableState)
      .then(
        data => {
          vm.policies = data.content
          vm.policies.forEach(policy => {
            policy.listed = 0 + policy.listedVods + policy.listedChannels + policy.listedLiveEvents + policy.listedTvShows
          })
          vm.isFound = !!vm.policies.length
          $scope.loading = false
        }
      )
  }

  /**
   * extends onOff() for intersection error handle
   */
  vm._onOff = function (policy) {
    vm.onOff(policy).catch(() => {
      policy.enabled = !policy.enabled
    })
  }

  vm.delete = function (urlPolicy) {
    urlPolicy._delete()
      .then(() => $scope.$broadcast('refreshTable'))
  }
}
